import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import AdminLayout from './layouts/AdminLayout'

// Lazy load pages
const AdminLoginPage = lazy(() => import('./pages/AdminLoginPage'))
const DashboardPage = lazy(() => import('./pages/DashboardPage'))
const UsersPage = lazy(() => import('./pages/UsersPage'))
const AppointmentsPage = lazy(() => import('./pages/AppointmentsPage'))
const ProvidersPage = lazy(() => import('./pages/ProvidersPage'))
const BillingPage = lazy(() => import('./pages/BillingPage'))
const SystemPage = lazy(() => import('./pages/SystemPage'))

// Loading component
function LoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-admin-dark">
      <div className="text-center">
        <div className="inline-block w-8 h-8 border-4 border-primary-500 border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-slate-400">Loading...</p>
      </div>
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          {/* Login route */}
          <Route path="/login" element={<AdminLoginPage />} />

          {/* Protected admin routes */}
          <Route path="/" element={<AdminLayout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="appointments" element={<AppointmentsPage />} />
            <Route path="providers" element={<ProvidersPage />} />
            <Route path="billing" element={<BillingPage />} />
            <Route path="system" element={<SystemPage />} />
          </Route>

          {/* Catch all - redirect to dashboard */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
